/**
 * global.js — نغمة ستور
 * أساس JavaScript عام للثيم. Vanilla JS فقط، بلا مكتبات ثقيلة.
 *
 * هذا الملف في مرحلة الأساس فقط: لا يوجد Header أو Footer أو أقسام تفاعلية
 * بعد، لذلك يقتصر على تهيئة مساحة الاسم (namespace) العامة وأدوات مساعدة
 * صغيرة ستُستخدم لاحقًا في header.js وcart-drawer.js وغيرها من ملفات
 * المراحل القادمة، دون تكرار هذا المنطق في كل ملف.
 */

(function () {
  "use strict";

  /*
    ملاحظة مهمة حول ترتيب التحميل:
    قد تُنشئ ملفات Liquid (مثل layout/theme.liquid) كائن window.Naghmah
    مبكرًا فقط لوضع routes/strings قبل تحميل هذا الملف. لذلك لا نستبدل
    window.Naghmah إن كان موجودًا، بل نُكمله (merge) حتى لا تُفقد أي بيانات
    وُضعت قبل تحميل هذا السكربت، ولا نُعيد كتابة الدوال إن كانت مُعرَّفة.
  */
  var Naghmah = window.Naghmah || {};

  /** يحمل true إذا كان المستخدم يفضّل تقليل الحركة */
  Naghmah.prefersReducedMotion = window.matchMedia
    ? window.matchMedia("(prefers-reduced-motion: reduce)").matches
    : false;

  /** سجل بسيط للوظائف التي تُهيَّأ عند تحميل/إعادة تحميل قسم من محرر الثيم */
  Naghmah._sectionInitializers = Naghmah._sectionInitializers || {};

  /**
   * تسجيل دالة تهيئة لقسم معيّن (تُستدعى عند التحميل الأول وعند
   * shopify:section:load من محرر الثيم). يدعم أكثر من ملف JS يسجّل
   * لنفس نوع القسم (مثال: header.js وmega-menu.js كلاهما يسجّلان لـ"header")
   * دون أن يحذف أحدهما تسجيل الآخر.
   * @param {string} sectionType
   * @param {(el: HTMLElement) => void} initFn
   */
  Naghmah.registerSection = Naghmah.registerSection || function (sectionType, initFn) {
    if (!this._sectionInitializers[sectionType]) {
      this._sectionInitializers[sectionType] = [];
    }
    this._sectionInitializers[sectionType].push(initFn);
  };

  /** دالة تأخير بسيطة (debounce) لاستخدامها في أحداث كثيرة كالتمرير وتغيير الحجم */
  Naghmah.debounce = Naghmah.debounce || function (fn, wait) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;
      window.clearTimeout(timeout);
      timeout = window.setTimeout(function () {
        fn.apply(context, args);
      }, wait || 150);
    };
  };

  /** تنفيذ دالة بعد جهوزية DOM */
  Naghmah.onReady = Naghmah.onReady || function (fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  };

  /** منع تمرير الصفحة خلف أي درج/قائمة مفتوحة (Mega Menu على الجوال، القائمة الجانبية، درج السلة) */
  Naghmah.lockScroll = Naghmah.lockScroll || function () {
    document.documentElement.classList.add("no-scroll");
    document.body.classList.add("no-scroll");
  };

  Naghmah.unlockScroll = Naghmah.unlockScroll || function () {
    document.documentElement.classList.remove("no-scroll");
    document.body.classList.remove("no-scroll");
  };

  /**
   * حصر التركيز (Focus trap) داخل عنصر مفتوح كنافذة/درج، لدعم لوحة المفاتيح
   * والوصول (Accessibility) دون كسر محرر الثيم.
   *
   * تصحيح: كانت القائمة تُحسب مرة واحدة فقط عند الفتح، فتشمل عناصر داخل
   * لوحات فرعية مخفية (مثال: زر إغلاق Mega Menu الخاص بالجوال وهو مخفي
   * فعليًا على سطح المكتب عبر display:none)، فيحاول Tab التركيز على عنصر
   * غير مرئي أصلاً. كما أن فتح/إغلاق لوحة فرعية أثناء بقاء الـdialog
   * مفتوحًا (مثال: توسيع قسم فرعي في Mega Menu) كان يغيّر مجموعة العناصر
   * القابلة للتركيز الفعلية دون أن يعكس ذلك الفخ المحسوب مسبقًا.
   */
  Naghmah.trapFocus = Naghmah.trapFocus || function (container, elementToFocus) {
    var FOCUSABLE_SELECTOR =
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function isVisible(el) {
      if (el.closest("[hidden]")) return false;
      var style = window.getComputedStyle(el);
      if (style.display === "none" || style.visibility === "hidden") return false;
      var rect = el.getBoundingClientRect();
      if (rect.width === 0 && rect.height === 0) return false;
      return true;
    }

    function getFocusable() {
      return Array.prototype.filter.call(
        container.querySelectorAll(FOCUSABLE_SELECTOR),
        isVisible
      );
    }

    var focusable = getFocusable();
    if (!focusable.length) return function () {};

    function onKeydown(evt) {
      if (evt.key !== "Tab") return;
      // إعادة الحساب في كل ضغطة Tab بدل الاعتماد على قائمة ثابتة محسوبة
      // عند الفتح فقط، لأن العناصر القابلة للتركيز فعليًا قد تتغيّر أثناء
      // بقاء الـdialog مفتوحًا.
      var current = getFocusable();
      if (!current.length) return;
      var first = current[0];
      var last = current[current.length - 1];
      if (evt.shiftKey && document.activeElement === first) {
        evt.preventDefault();
        last.focus();
      } else if (!evt.shiftKey && document.activeElement === last) {
        evt.preventDefault();
        first.focus();
      }
    }

    container.addEventListener("keydown", onKeydown);
    (elementToFocus || focusable[0]).focus();

    return function removeTrap() {
      container.removeEventListener("keydown", onKeydown);
    };
  };

  window.Naghmah = Naghmah;

  // دعم إعادة تهيئة الأقسام داخل محرر الثيم دون تكسير الصفحة.
  // ملاحظة: event.target هو الغلاف (wrapper) الذي يولّده Shopify تلقائيًا
  // حول القسم (<div id="shopify-section-...">)، وهو لا يحمل data-section-type
  // بنفسه. لذلك نبحث داخله عن العنصر الذي وضعناه فعليًا بهذا الوصف في
  // Liquid، ونمرّره هو (لا الغلاف) لدالة التهيئة.
  document.addEventListener("shopify:section:load", function (event) {
    var wrapper = event.target;
    if (!wrapper || !wrapper.querySelector) return;
    var typedEl = wrapper.matches && wrapper.matches("[data-section-type]")
      ? wrapper
      : wrapper.querySelector("[data-section-type]");
    var type = typedEl ? typedEl.dataset.sectionType : null;
    if (type && Naghmah._sectionInitializers[type]) {
      Naghmah._sectionInitializers[type].forEach(function (initFn) {
        initFn(typedEl);
      });
    }
  });

  Naghmah.onReady(function () {
    document.documentElement.classList.add("js-ready");
  });
})();
